import { ReactElement } from 'react';
import compose from '../../../utils/components/_compose';
import withUniqueId from '../../../hocs/helpers/_withUniqueId';
import injectTranslations from '../../../hocs/translation/injectTranslations';

import fr from './translations/fr';
import en from './translations/en';

import AutoSuggestResourceInput, { AutoSuggestResourceInputProps } from './AutoSuggestResourceInput';

export * from './AutoSuggestResourceInput';

const ComposedAutoSuggestResourceInput: <Value, Data>(props: AutoSuggestResourceInputProps<Value, Data>) => ReactElement<AutoSuggestResourceInputProps<Value, Data>> = compose<any>(
  withUniqueId('autoSuggestId'),
  injectTranslations('Core.AutoSuggestResourceInput', [
    { language: 'fr', resource: fr },
    { language: 'en', resource: en },
  ]),
)(AutoSuggestResourceInput);

export default ComposedAutoSuggestResourceInput;
